module.exports = exports = require('./DamWebParser');



//////////////////
// WEBPACK FOOTER
// ./~/draughts-damweb-parser/src/main.js
// module id = irHR
// module chunks = 4